export default {
  paperAnchorLeft: {
    borderTopRightRadius: '20px',
    borderBottomRightRadius: '20px'
  }
};
